import * as React from 'react';
import defaultAvatar from '@images/web/default.png';
import { GuildPkRoundItem, GuildPkMatchItem } from '@/fetch.ts';

const PkItem: React.FC<GuildPkRoundItem> = props => (
  <li className='web-pkItem'>
    <div className='pkItem-top'>
      <div className='pkItem-top-lr'>
        <img
          src={props.sAttGuildLogo}
          title={props.sAttGuildName}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
        />
        <p>{props.sAttGuildName}</p>
      </div>
      <div className='pkItem-top-mid'>
        {props.iAttWin} : {props.iDefWin}
      </div>
      <div className='pkItem-top-lr'>
        <img
          src={props.sDefGuildLogo}
          title={props.sDefGuildName}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
        />
        <p>{props.sDefGuildName}</p>
      </div>
    </div>
    <div className='pkItem-bottom'>
      {
        props.vMatch.value.map((item: GuildPkMatchItem) => (
          <div className='pkItem-bottom-Item' key={item.iMatch}>
            <div className='pkItem-bottom-lr left'>
              <div className='lr-avatar'>
                <img
                  src={item.tAttSide.sLogoUrl}
                  title={item.tAttSide.sNickName}
                  onError={(event: any): void => {
                    event.target.onerror = null;
                    event.target.src = defaultAvatar;
                  }}
                  onClick={(): void => {
                    window.open('https://m.huya.com/' + item.tAttSide.tJump.iRoomId, '_blank');
                  }}
                />
                <i className={`avatar-label ${item.iResult === 0 ? '' : ['win', 'lose'][item.iResult - 1]}`} />
              </div>
              <div className='lr-text'>
                <h1
                  onClick={(): void => {
                    window.open('https://m.huya.com/' + item.tAttSide.tJump.iRoomId, '_blank');
                  }}
                >{item.tAttSide.sNickName}</h1>
                {item.iResult !== 0 && <p>{item.tAttSide.lScore}</p>}
              </div>
            </div>
            <div className={`pkItem-bottom-mid type-${item.iStatus}`}>{item.sDesc}</div>
            <div className='pkItem-bottom-lr right'>
              <div className='lr-text'>
                <h1
                  onClick={(): void => {
                    window.open('https://m.huya.com/' + item.tDefSide.tJump.iRoomId, '_blank');
                  }}
                >{item.tDefSide.sNickName}</h1>
                {item.iResult !== 0 && <p>{item.tDefSide.lScore}</p>}
              </div>
              <div className='lr-avatar'>
                <img
                  src={item.tDefSide.sLogoUrl}
                  title={item.tDefSide.sNickName}
                  onError={(event: any): void => {
                    event.target.onerror = null;
                    event.target.src = defaultAvatar;
                  }}
                  onClick={(): void => {
                    window.open('https://m.huya.com/' + item.tDefSide.tJump.iRoomId, '_blank');
                  }}
                />
                <i className={`avatar-label ${item.iResult === 0 ? '' : ['lose', 'win'][item.iResult - 1]}`} />
              </div>
            </div>
          </div>
        ))
      }
    </div>
  </li>
)

export default PkItem;